import HttpError from "standard-http-error"
import Bugsnag from "@bugsnag/js"

import api, { Payload, Query } from "src/helpers/api"

const request = async <T>(method: string, name: string, params?: Payload | Query): Promise<T | null> => {
  try {
    const response = await api.request<T>(method, `/.netlify/functions/${name}`, params)
    return response
  } catch (error) {
    alert(`An error happened. Please try again.
If the problem persists, please email contact@pierreplume.fr

Error message: ${error.message}`)
    return null
  }
}

export default {
  get: <T = unknown>(name: string, params?: Query) => request<T>("GET", name, params),
  post: <T = unknown>(name: string, params: Payload) => request<T>("POST", name, params),
  put: <T = unknown>(name: string, params: Payload) => request<T>("PUT", name, params),
  delete: <T = unknown>(name: string, params: Payload) => request<T>("DELETE", name, params),
}

export const handleError = (error: Error) => {
  if (!(error instanceof HttpError)) {
    Bugsnag.notify(error)
  }
  alert(`Error: ${error.message}`)
}
